export const mutations = {
  setTiers(state, data) {
    state.tiers = data;
  },

  setFilters(state, data) {
    state.filters = data;
  },

  setCategories(state, data) {
    state.categories = data;
  },

  setCollections(state, data) {
    state.collections = data;
  },

  setBadges(state, data) {
    state.badges = data;
  },

  setLoading(state, value) {
    state.loading = value;
  },

  setDetails(state, data) {
    state.details = data;
  },
};
